import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Icons } from '../../../common/Icons';

import AddStoreCategoryDialog from './AddStoreCategoryDialog';
import EditStoreCategoryDialog from './EditStoreCategoryDialog';
import StoreCategoriesList from './StoreCategoriesList';
import TopHeader from '../../../views/components/TopHeader';

import { storeCategoriesMng } from '../api/storeCategoriesMng';

function StoreCategoriesDialog(props) {
  const { open, onClose } = props;

  const [openAddStoreCategory, setOpenAddStoreCategory] = React.useState(false);
  const [openEditStoreCategory, setOpenEditStoreCategory] = React.useState(false);
  const [selectedStoreCategory, setSelectedStoreCategory] = React.useState();
  const [storeCategories, setStoreCategories] = React.useState();

  const getStoreCategories = async () => {
    const storeCategories = await storeCategoriesMng.getStoreCategories();
    setStoreCategories(storeCategories);
  };

  React.useEffect(() => {
    getStoreCategories();
  }, []);

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <TopHeader
          title={'Store Categories'}
          onClose={onClose}
          icon={<Icons.Category size={20} />}
          actionLabel={'Add Category'}
          onAction={() => {
            setSelectedStoreCategory(false);
            setOpenAddStoreCategory(true);
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0px' }}>
        <StoreCategoriesList
          storeCategories={storeCategories}
          onEdit={(storeCategory) => {
            setSelectedStoreCategory(storeCategory);
            setOpenEditStoreCategory(true);
          }}
          onDelete={getStoreCategories}
        />
      </DialogContent>
      {openAddStoreCategory && (
        <AddStoreCategoryDialog
          open={openAddStoreCategory}
          onAdd={getStoreCategories}
          onClose={() => {
            setOpenAddStoreCategory(false);
            setSelectedStoreCategory(null);
          }}
        />
      )}
      {openEditStoreCategory && (
        <EditStoreCategoryDialog
          open={openEditStoreCategory}
          storeCategory={selectedStoreCategory}
          onEdit={getStoreCategories}
          onClose={() => {
            setOpenEditStoreCategory(false);
            setSelectedStoreCategory(false);
          }}
        />
      )}
    </Dialog>
  );
}

StoreCategoriesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default StoreCategoriesDialog;
